import { AppState } from 'react-native';
/**
 * Waits for the app state to change to 'active' and then resolves.
 */
export default async function waitForAppStateRefocus() {
    return new Promise<void>((resolve) => {
        const subscription = AppState.addEventListener('change', (nextAppState) => {
            if (nextAppState === 'active') {
                subscription.remove();
                resolve();
            }
        });
    });
}
